/** 此文件函数，请保证初始化的数据必须是调用就初始化，没有任何外部依赖，否则请在其他地方建立函数 */
/**
 * @description 初始化 nc 数据参数
 * @param ncSetting
 */
export function initProductionNcSetting(ncSetting: INcSetting) {
  ncSetting.drawPlankWidth = ncSetting.xyReverse
    ? ncSetting.panelSize.plankHeight
    : ncSetting.panelSize.plankWidth
  ncSetting.drawPlankHeight = ncSetting.xyReverse
    ? ncSetting.panelSize.plankWidth
    : ncSetting.panelSize.plankHeight
  return ncSetting
}
